import { FC } from 'react';
import { TaskStatus } from '@/common/components/business/ExpandStore/ts-config';
import { isNotEmptyAny } from '@lhb/func';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import { formatTerminateText, getTerminateReasonDetailItems, rejectTipImg, TaskTerminateInfoData } from './config';
import styles from './index.module.less';

const TaskTerminateInfo: FC<{
  detail: TaskTerminateInfoData & {
    status?: number;
  };
}> = ({
  detail,
}) => {
  const visible = detail?.status === TaskStatus.Closed && [
    detail?.closeReasonName,
    detail?.closeDetailReason,
    detail?.closeApprovalReason,
  ].some(item => isNotEmptyAny(item));

  if (!visible) return <></>;

  return (
    <div className={styles.terminateInfo}>
      <img className={styles.title} src={rejectTipImg} alt='终止原因' />
      <div className={styles.content}>
        <div className={styles.contentTitle}>{formatTerminateText(detail?.closeReasonName)}</div>
        {getTerminateReasonDetailItems(detail).map(item => (
          <V2DetailItem
            className={styles.item}
            direction='horizontal'
            key={item.label}
            label={item.label}
            rows={1}
            textAreaRows={1}
            type='textarea'
            useMoreBtn
            value={formatTerminateText(item.value)}
          />
        ))}
      </div>
    </div>
  );
};

export default TaskTerminateInfo;
